var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1800 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1660,100H1440a40,40,0,0,0-40,40h0V300h0V460h0a40,40,0,0,0,40,40h220a40,40,0,0,0,40-40h0a40,40,0,0,0-40-40H1520a40,40,0,0,1-40-40h0a40,40,0,0,1,40-40h100a40,40,0,0,0,40-40h0a40,40,0,0,0-40-40H1520a40,40,0,0,1-40-40h0a40,40,0,0,1,40-40h140a40,40,0,0,0,40-40h0A40,40,0,0,0,1660,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1120,180h160a40,40,0,0,0,40-40h0a40,40,0,0,0-40-40H1120a120,120,0,0,0,0,240h80a40,40,0,0,1,40,40h0a40,40,0,0,1-40,40H1040a40,40,0,0,0-40,40h0a40,40,0,0,0,40,40h160a120,120,0,0,0,0-240h-80a40,40,0,0,1-40-40h0A40,40,0,0,1,1120,180Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280,100H140a40,40,0,0,0-40,40V460c0,22.09,7.91,40,30,40H280c110.46,0,200-89.54,200-200S390.46,100,280,100Zm84.85,284.85A120,120,0,1,1,400,300,119.19,119.19,0,0,1,364.85,384.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.89,261.11l-31.82-31.82a10,10,0,0,0-14.14,0l-31.82,31.82a55,55,0,1,0,77.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M740,180a120,120,0,1,1-84.85,35.15A119.19,119.19,0,0,1,740,180m0-80c-110.46,0-200,89.54-200,200s89.54,200,200,200,200-89.54,200-200S850.46,100,740,100Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.81a9851899705ee3161c6c72f7cfeda7.svg";
export { ForwardRef as ReactComponent };